import { useState } from "react";
import { BottomSheet } from "../ui/BottomSheet/BottomSheet.tsx";
import { Button } from "../ui/Button/Button.tsx";
import { useInstall } from "./InstallProvider.tsx";
import styles from "./InstallApp.module.css";

/** Available before login and in the account, with manual help for Safari/iOS. */
export function InstallApp() {
  const { installed, installing, available, install } = useInstall();
  const [help, setHelp] = useState(false);
  const [error, setError] = useState(false);
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (installed) return null;

  async function start() {
    setError(false);
    const result = await install();
    if (result === "instructions" || result === "error") {
      setError(result === "error");
      setHelp(true);
    }
  }

  return (
    <section className={styles.card} aria-label="Приложение E-va">
      <div className={styles.intro}>
        <img src="/icons/icon-192.png" width="44" height="44" alt="" className={styles.icon} />
        <div>
          <p className={styles.title}>E-va на вашем экране</p>
          <p className={styles.hint}>Открывайте с иконки, как приложение.</p>
        </div>
      </div>
      <Button variant="secondary" loading={installing} onClick={() => void start()} aria-haspopup="dialog">
        Установить приложение
      </Button>
      <BottomSheet open={help} onClose={() => setHelp(false)} title="Установить E-va">
        {error && <p className={styles.hint} role="alert">Окно установки не открылось. Попробуйте через меню браузера.</p>}
        {ios ? (
          <ol className={styles.steps}>
            <li>Откройте эту страницу в Safari.</li>
            <li>Нажмите «Поделиться» — значок квадрата со стрелкой вверх (может быть в меню «…»).</li>
            <li>Выберите «На экран Домой». Если есть переключатель «Открывать как веб-приложение», включите его.</li>
            <li>Нажмите «Добавить». Иконка E-va появится на домашнем экране.</li>
          </ol>
        ) : (
          <>
            <p className={styles.hint}>В Chrome, Edge или Яндекс Браузере откройте меню и выберите «Установить приложение» или «Добавить на главный экран». На компьютере значок установки может быть в адресной строке.</p>
            <p className={styles.hint}>В Safari на Mac выберите «Файл» → «Добавить в Dock». Если пункта установки нет, откройте ссылку в другом браузере.</p>
          </>
        )}
        <p className={styles.hint}>Для входа и отправки сообщений нужен интернет.</p>
        {available && <Button loading={installing} onClick={() => void start()}>Установить сейчас</Button>}
        <Button variant="secondary" onClick={() => setHelp(false)}>Понятно</Button>
      </BottomSheet>
    </section>
  );
}
